"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var SearchBar = /** @class */ (function (_super) {
    __extends(SearchBar, _super);
    function SearchBar(props) {
        var _this = _super.call(this, props) || this;
        _this.onSearch = function (event) {
            //console.log("SearchBar onSearch");
            //console.log(event.target.value);
            _this.props.onSearch(event.target.value);
        };
        _this.searchInputRef = React.createRef();
        return _this;
    }
    SearchBar.prototype.componentDidMount = function () {
        document.addEventListener("search", this.onSearch);
    };
    SearchBar.prototype.componentWillUnmount = function () {
        document.removeEventListener("search", this.onSearch);
    };
    SearchBar.prototype.render = function () {
        var _this = this;
        return (React.createElement(reactstrap_1.InputGroup, null,
            React.createElement(reactstrap_1.Input, { placeholder: this.props.resources.SearchDotDotDot, type: "search", innerRef: this.searchInputRef }),
            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "append" },
                React.createElement(reactstrap_1.Button, { color: "primary", onClick: function () { var _a; _this.props.onSearch((_a = _this.searchInputRef.current) === null || _a === void 0 ? void 0 : _a.value); } },
                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faSearch })))));
    };
    return SearchBar;
}(React.Component));
exports.SearchBar = SearchBar;
//# sourceMappingURL=SearchBar.js.map